export default __webpack_public_path__ + "media/images/corp/home-1f7f51be57f25188326b72fe1911005b.png";